import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ConsultationsDataTable {
  constructor() {
    $(document).ready(function() {
      showConsultationsTable();
    });

    $(document).on("turbo:render", function() {
      showConsultationsTable();
    });

    function showConsultationsTable() {
      $('#person-consultations-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#person-consultations-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "consultation_type"},
          {"data": "consultation_sub_type"},
          {"data": "consultation_date"},
          {"data": "project"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
